import { NgModule } from '@angular/core';
import { CxUiModule } from '../shared/cx-ui/cx-ui.module';
import { cxDateFirstDayOfWeekProvider } from './cx-date-first-day-of-week-provider';
import { cxDateFormatProvider } from './cx-date-format-provider';
import { cxDateLanguageProvider } from './cx-date-language-provider';
import { cxRTLProvider } from './cx-rtl-provider';
import { cxTimeFormatProvider } from './cx-time-format-provider';
import { cxDateControlButtonsProvider } from './cx-date-control-buttons-provider';
import { cxTimeControlButtonsProvider } from './cx-time-control-buttons-provider';
import { cxDateHideResetButtonProvider } from './cx-date-hide-reset-button-provider';
import { cxTimeHideResetButtonProvider } from './cx-time-hide-reset-button-provider';
import { cxDateLabelsControlButtonsProvider } from './cx-date-labels-control-buttons.provider';
import { cxTimeLabelsControlButtonsProvider } from './cx-time-labels-control-buttons.provider';

@NgModule({
  imports: [
    CxUiModule.forRoot({
      designVersion: 'v2',
    }),
  ],
  providers: [
    cxRTLProvider,
    cxDateFormatProvider,
    cxDateLanguageProvider,
    cxDateFirstDayOfWeekProvider,
    cxTimeFormatProvider,
    cxDateControlButtonsProvider,
    cxTimeControlButtonsProvider,
    cxDateHideResetButtonProvider,
    cxTimeHideResetButtonProvider,
    cxDateLabelsControlButtonsProvider,
    cxTimeLabelsControlButtonsProvider,
  ],
})
export class CxUiRootModule {}
